<template>
    <div>
        <div class="offcanvas offcanvas-end" tabindex="-1" id="quickToolsBar" aria-labelledby="quickToolsBarLabel" style="width: 32%;">
            <div class="offcanvas-header bg-black border-dark border-start">
                <div>
                    <h4 class="offcanvas-title text-info fw-light" id="appSelectorBarLabel">Q u i c k b a r</h4>
                </div>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div class="offcanvas-body border-dark border-start" style="background-color: rgb(0,7,18);">
                <div class="row p-2">
                    <div class="input-group flex-nowrap bg-black">
                        <button class="btn fs-5 bg-transparent gradient-text " style="width: 15%;" :title="`Current user: ${username}`">
                            <i class="fa-solid fa-xl fa-user me-4"></i>
                        </button>
                        <div class="btn bg-input fs-5 text-info border-0 border-end border-info" style="width: 85%;" title="Kraken username.">
                            {{username}}
                        </div>
                    </div>
                    <div class="input-group flex-nowrap bg-black mt-1">
                        <button class="btn fs-5 bg-transparent gradient-text " style="width: 15%;" :title="`Customer: ${customer}`">
                            <i class="fa-solid fa-xl fa-leaf me-4"></i>
                        </button>
                        <div class="btn bg-input fs-5 text-info border-0 border-end border-info" style="width: 85%;" title="Kraken customer.">
                            {{customer}}
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="">
                        <div class="bg-black p-3 w-100">
                            <div class="input-group flex-nowrap">
                                <input v-if="!show_requirements" type="text" class="btn text-start text-info fs-5 w-100" style="cursor: default; pointer-events:none;" value="Change Password" readonly>
                                <input v-if="show_requirements" type="text" class="btn text-start text-info fs-5 w-100" style="cursor: default; pointer-events:none;" value="Password Requirements" readonly>
                                <button class="btn gradient-text fs-6 rounded w-25" title="View requirements." @click="show_requirements = !show_requirements">
                                    <i class="fa-solid fa-xl fa-info" :class="{'fa-info': !show_requirements, 'fa-key': show_requirements }"></i>
                                </button>
                            </div>
                            <div v-if="show_requirements">
                                <div class="input-group flex-nowrap mt-2">
                                    <div class="w-100">
                                        <ul class="list-group">
                                            <li v-for="(condition, i) in passreqs" :key="i" class="list-group-item bg-transparent">
                                                <button class="btn btn-kraken w-100 text-start" style="pointer-events: none; cursor: default; font-size: 13px;">
                                                    {{condition}}
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!show_requirements">    
                                <div class="input-group flex-nowrap mt-2">
                                    <button class="btn btn-kraken fs-6" style="width: 15%;" :disabled="changingPass">
                                        <i class="fa-solid fa-xl fa-key"></i>
                                    </button>
                                    <form class="w-100">
                                        <input type="password" autocomplete="false" class="btn bg-input text-info fs-6 w-100" placeholder="New Password" v-model="passchange.new" style="cursor: text;" :disabled="changingPass">
                                    </form>
                                </div>
                                <div class="input-group flex-nowrap mt-1">
                                    <button class="btn btn-kraken fs-6" style="width: 15%;" :disabled="changingPass">
                                        <i class="fa-solid fa-xl fa-check-double"></i>
                                    </button>
                                    <form class="w-100">
                                        <input type="password" autocomplete="false" class="btn bg-input text-info fs-6 w-100" placeholder="Confirmation"  v-model="passchange.confirmation" style="cursor: text;" :disabled="changingPass">
                                    </form>
                                </div>
                                <div class="input-group flex-nowrap mt-1">
                                    <button class="btn btn-kraken fs-5 w-100" :disabled="!passchange.new || !passchange.confirmation || (passchange.new != passchange.confirmation) || changingPass" @click="Changepass">
                                        <i class="fa-solid fa-xl fa-check" :class="{'fa-check':!changingPass , 'fa-spinner fa-spin': changingPass}"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top: 70%;">
                    <div class="input-group flex-nowrap bg-transparent p-3 w-100 rounded text-end">
                        <div style="width:70%"></div>
                        <button class="btn bg-transparent gradient-text fs-5 text-end border-0 border-bottom border-top border-primary" style="width: 30%;" @click="logout" title="Logout from Kraken.">
                            <span>Exit</span>
                            <i class="fa-solid fa-xl fa-right-from-bracket ms-3"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from "axios";

export default {
    name: 'QuickBar',
    props:{
        username: String,
        customer: String
    },
    data(){
        return {
            // General
            site: null,
            // Password change.
            show_requirements: false,
            passreqs: [
                "Minimum 15 characters in length.",
                "At least one uppercase english letter. ( A-Z )",
                "At least one lowercase english letter. ( a-z )",
                "At least one digit. ( 0-9 )",
                "At least one special characters. ( #?!@$%^&*- )"
            ],
            changingPass: false,
            passchange: {
                new: null,
                confirmation: null
            },
            dpasschange: {
                new: null,
                confirmation: null
            }
        }
    },
    components: {},
    methods: {
        logout(ask=true){
            if (ask){
                if (!confirm('Exit from KRAKEN?')){
                    return
                }
            }
            const dest = this.site + '/suite/main/logout'
            axios.post(dest, {})
                .then(rx => {
                    this.$router.push("/login")
                })
                .catch(error => {
                    try {
                        alert(error.response.data.errorMessage)
                    } catch (error) {
                        alert("Failed connection with server, check your connection.")
                    }
                });
        },
        moveRoute(routeName){
            // Protection.
            const cr = this.$route.path
            if (cr != routeName){
                this.$router.push(routeName)
            }
        },
        // Password change.
        Changepass(){
            if (!confirm('Change your current password?')){
                return
            }
            this.changingPass = true
            const params = { newsecret: this.passchange.new, 
                             confirmation: this.passchange.confirmation, 
                             reset: false }
            const dest = this.site + '/suite/main/alterPassword'
            axios
                .post(dest, {params})
                .then(rx => {
                    // OK
                    alert(rx.data.message)
                    this.passchange.new = null
                    this.passchange.confirmation = null
                    this.changingPass = false
                    this.logout(false)
                })
                .catch(error => {
                    try {             
                        alert(error.response.data.errorMessage)
                    } catch (error) {
                        alert("Failed connection with server, check your connection.")
                    }
                    // Some Error
                    this.changingPass = false
                });
        },
        getCookie(name){
            const cookies = document.cookie.split(';');
            for (let cookie of cookies) {
                    cookie = cookie.trim();
                    if (cookie.startsWith(name + '=')) {
                    return cookie.substring(name.length + 1);
                    }
            }
            return null;
        }
    },
    created: function(){
        this.stage = process.env.NODE_ENV
        this.service_mode = process.env.VUE_APP_SERVICE_MODE
        if (this.stage == 'development'){
            this.site = process.env.VUE_APP_SERVICE_URL
        }
        else{
            this.site = `${window.location.protocol}//${window.location.host}/kraken`
        }
        // Setting
        axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
    }
}
</script>

<style scoped>

    .btn-kraken{
        background-color: rgb(20, 63, 162);
        color: white;
    }
    .btn-kraken:hover{
        background-color: rgb(30, 87, 162);
        color: black;
    }

    .bg-gradient{
       background-image: linear-gradient(rgb(57, 198, 249), rgb(0, 34, 90));
       color: transparent;
       background-clip: text;
    }
    .bg-gradient:hover{
        background-image: linear-gradient(rgb(0, 34, 90), rgb(57,198,249));
        color: transparent;
        background-clip: text;
    }

    .gradient-text{
        background-image: linear-gradient(rgb(57, 198, 249), rgb(0, 34, 90));
        color: transparent;
        background-clip: text;
    }
    .gradient-text:hover{
        background-image: linear-gradient(rgb(0, 34, 90), rgb(57,198,249));
        color: transparent;
        background-clip: text;
    }

    .bg-input{
        background-color: rgb(7,13,15);
        color: white;
    }

</style>